import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './LoadingOverlay.css';
import './ProductDetailPage.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, ScrollRestoration } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
<BrowserRouter>
  
    <App />
   
    </BrowserRouter>
);
/*
root.render(

  <BrowserRouter>
  <ScrollRestoration />
   <App />
   </BrowserRouter>
 
   
);
*/
// React.StrictMode
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
